<template>
    <!-- eslint-disable vue/html-indent  -->
    <div class="data-charts-module">
        <DashboardLayoutComponent>
            <DataCharts
                :analytics-data="analyticsData"
                :is-loading="isLoading"
                @on-click-table-data="onShowInnerChart($event)"
            />
        </DashboardLayoutComponent>
    </div>
</template>
<script>
import DashboardLayoutComponent from "@Layouts/dashboard/";
import DataCharts from "@DataChartsModule/module";
import useAnalytics from "@Functions/useAnalytics.js";
import { useCookies } from "vue3-cookies";
import { Tokens } from "@Utilities/enum";

export default {
    name: "DataChartsModule",
    components: {
        DashboardLayoutComponent,
        DataCharts,
    },
    setup() {
        const { cookies } = useCookies();
        const { analyticsData, isLoading, currentRoute } = useAnalytics();

        const onShowInnerChart = (data) => {
            let saveSections = cookies.get(Tokens.MenuNav).item;
            const { id, slug, type, label } = data;

            saveSections.type = type;

            const defaultValue = {
                id,
                slug,
                name: label,
                children: null,
            };

            if (type === "classes") {
                saveSections.level2 = defaultValue;
                saveSections.level3 = {};
            } else if (type === "sub_tc") {
                saveSections.level3 = defaultValue;
                saveSections.type = "sub-class";
            }

            saveSections.slug = slug;

            cookies.set(Tokens.MenuNav, {
                current: 'Therapeutic Class',
                item: saveSections,
                type: '',
            });

            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });

            let metric_type = type === "sub_tc" ? "sub-class" : type;
            if ((_.includes([ "main_tc", "sub_tc", "brand" ]), metric_type)) {

                const { attribute, dimension } = currentRoute.value.params;

                let uri = `/report/${dimension}/${attribute}/${metric_type}`;

                if (metric_type === 'brand') {
                    uri = `/report/drug-info/form/${metric_type}`;
                }

                if (metric_type === 'generic') {
                    uri = `/report/drug-info/form/${metric_type}`;
                }

                if (slug) {
                    uri = uri + `?slug=${slug}`;
                }

                if (metric_type === 'brand' && slug){
                    if (_.isEmpty(saveSections.level1))
                        uri = uri + '&sort=brand'

                    let sub_class_id = saveSections?.level3?.id ?? saveSections?.level2?.id
                    if (sub_class_id)
                        uri += '&sub_class=' + sub_class_id
                }

                if (metric_type === 'generic' && slug && _.isEmpty(saveSections.level1)){
                    uri = uri + '&sort=generic'
                }
                window.location.href = uri;
            }
        };

        return {
            isLoading,
            analyticsData,
            onShowInnerChart,
        };
    },
};
</script>

<style lang="scss">
.data-charts-module {
    .chart-container__wrapper__data {
        @apply w-full;
        .chart-wrapper {
            @apply flex items-center justify-center h-full;
        }
    }
    .chart-container__wrapper__header {
        @apply p-0;
    }
    .spinner-component {
        @apply flex items-center justify-center;
        min-height: 67vh;
    }
    .watermark-wrapper {
        p {
            @apply inline-block p-6 text-gray-100;
        }
        .watermark {
            @apply relative origin-center -z-10;
            transform: rotate(-45deg) translateX(0%) translateY(-50%);
            width: 300%;
            height: 200vh;
            min-height: 1000px;
        }
    }
}
@screen sm {
    .data-charts-module {
        .watermark-wrapper {
            .watermark {
                transform: rotate(-45deg) translateX(0%) translateY(-70%);
            }
        }
    }
}
@screen lg {
    .data-charts-module {
        .watermark-wrapper {
            .watermark {
                transform: rotate(-45deg) translateX(0%) translateY(-105%);
            }
        }
    }
}
</style>
